module.exports = __webpack_public_path__ + "img/software3.fa181021.jpg";